import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    confirmationDocumentURL01: Yup.string()
      .nullable()
      .url()
      .required('required'),
    confirmationDocumentURL02: Yup.string()
      .nullable()
      .url()
      .required('required'),
  }),
});
